module.exports = __webpack_public_path__ + "static/media/paul.cf921b2e.jpg";